import React, { useState, useEffect } from "react";
// import "@ant-design/compatible/assets/index.css";
import "antd/dist/antd.css";
import { Popover, Space, Row, Select, Radio, Input, Checkbox } from "antd";
import moment from "moment";

const { Option } = Select;

const lastDayConst = "lastday";

const scheduleFrequencies = {
  MONTHLY: "Monthly",
  QUARTERLY: "Quarterly",
  YEARLY: "Yearly",
};

const weekdays = {
  0: "Sunday",
  1: "Monday",
  2: "Tuesday",
  3: "Wednesday",
  4: "Thursday",
  5: "Friday",
  6: "Saturday",
};

const months = {
  1: "January",
  2: "February",
  3: "March",
  4: "April",
  5: "May",
  6: "June",
  7: "July",
  8: "August",
  9: "September",
  10: "October",
  11: "November",
  12: "December",
};

const getSuffix = (prefix) => {
  let suffix = "";
  switch (prefix) {
    case 1:
      suffix = "st";
      break;
    case 2:
      suffix = "nd";
      break;
    case 3:
      suffix = "rd";
      break;
    default:
      suffix = "th";
      break;
  }
  return suffix;
};

const createMonthRadioOptions = (limit) => {
  limit = limit ? limit : 31;
  let radioOptions = [];
  let rowContent = [];

  for (let x = 1; x <= limit; x++) {
    let modWeek = x % 7;

    rowContent.push(
      <Radio.Button style={{ width: 48, marginBottom: 4 }} value={x}>
        {x}
      </Radio.Button>
    );

    if (modWeek === 0 || x === limit) {
      radioOptions.push(<Row>{[...rowContent]}</Row>);
      rowContent = [];
    }
  }

  return radioOptions;
};

const createWeekOptions = () => {
  return (
    <>
      <Radio.Button value={1}>Week 1</Radio.Button>
      <Radio.Button value={2}>Week 2</Radio.Button>
      <Radio.Button value={3}>Week 3</Radio.Button>
      <Radio.Button value={4}>Week 4</Radio.Button>
    </>
  );
};

const createDaysOfWeekOptions = () => {
  return (
    <>
      <Radio value={1}>M</Radio>
      <Radio value={2}>T</Radio>
      <Radio value={3}>W</Radio>
      <Radio value={4}>T</Radio>
      <Radio value={5}>F</Radio>
      <Radio value={6}>S</Radio>
      <Radio value={0}>S </Radio>
    </>
  );
};

const reverseSchedule = (schedule, triggerFrequency, triggerScheduleType) => {
  if (!schedule) {
    return "";
  }
  
  if (triggerScheduleType === 1) {
    if (triggerFrequency === scheduleFrequencies.MONTHLY) {
      return schedule !== "lastday" ? schedule : "last day";
    }
    // else if (triggerFrequency === scheduleFrequencies.QUARTERLY) {
    //   if (!monthValue && !dayOfMonthValue) {
    //     return;
    //   }
    //   if (!monthValue) {
    //     setMonthValue(1);
    //     return;
    //   } else if (!dayOfMonthValue) {
    //     setDayOfMonthValue(1);
    //     return;
    //   }
    //   formattedPopupValue =
    //     monthValue + getSuffix(monthValue) + " month " + dayOfMonthValue;
    //   formattedScheduleValue =
    //     monthValue + "_" + lastday ? lastDayConst : dayOfMonthValue;
    // } else if (triggerFrequency === scheduleFrequencies.YEARLY) {
    //   if (!monthValue && !dayOfMonthValue) {
    //     return;
    //   }
    //   if (!monthValue) {
    //     setMonthValue("1");
    //     return;
    //   } else if (dayOfMonthValue === undefined) {
    //     setDayOfMonthValue(1);
    //     return;
    //   }

    //   formattedPopupValue =
    //     monthValue + getSuffix(monthValue) + " month " + dayOfMonthValue;
    //   formattedScheduleValue =
    //     monthValue + "_" + lastday ? lastDayConst : dayOfMonthValue;
    // } else {
    //   return;
    // }
  } else if (triggerScheduleType === 2) {
    if (triggerFrequency === scheduleFrequencies.MONTHLY) {
      const splitted = schedule.split("_");
      return `${splitted[0] + getSuffix(splitted[0])} week ${splitted[1]}`;
    }
    // else if (triggerFrequency === scheduleFrequencies.QUARTERLY) {
    //   let redo = false;
    //   if (!weekValue && dayOfWeekValue === undefined && !monthValue) {
    //     return;
    //   } else if (!weekValue) {
    //     setWeekValue(1);
    //     redo = true;
    //   } else if (dayOfWeekValue === undefined) {
    //     setDayOfWeekValue(1);
    //     redo = true;
    //   } else if (!monthValue) {
    //     setMonthValue(1);
    //     redo = true;
    //   }
    //   if (redo) {
    //     return;
    //   }

    //   formattedPopupValue =
    //     monthValue +
    //     getSuffix(monthValue) +
    //     " month " +
    //     weekValue +
    //     getSuffix(weekValue) +
    //     " week " +
    //     weekdays[dayOfWeekValue];

    //   formattedScheduleValue =
    //     monthValue + "_" + weekValue + "_" + weekdays[dayOfWeekValue];
    // } else if (triggerFrequency === scheduleFrequencies.YEARLY) {
    //   let redo = false;
    //   if (!weekValue && dayOfWeekValue === undefined && !monthValue) {
    //     return;
    //   } else if (!weekValue) {
    //     setWeekValue(1);
    //     redo = true;
    //   } else if (dayOfWeekValue === undefined) {
    //     setDayOfWeekValue(1);
    //     redo = true;
    //   } else if (!monthValue) {
    //     setMonthValue("1");
    //     redo = true;
    //   }
    //   if (redo) {
    //     return;
    //   }

    //   formattedPopupValue =
    //     monthValue +
    //     getSuffix(monthValue) +
    //     " month " +
    //     weekValue +
    //     getSuffix(weekValue) +
    //     " week " +
    //     weekdays[dayOfWeekValue];

    //   formattedScheduleValue =
    //     monthValue + "_" + weekValue + "_" + weekdays[dayOfWeekValue];
    // } else {
    //   return;
    // }
  }
}

const PopupTriggerSchedule = (props) => {
  const {
    triggerFrequency,
    triggerScheduleType,
    setTriggerSchedule,
    placeholder,
    simpleOptionGenerator,
    presetValue,
    hotelChanged
  } = props;

  const [monthValue, setMonthValue] = useState(undefined);
  const [weekValue, setWeekValue] = useState(undefined);
  const [dayOfWeekValue, setDayOfWeekValue] = useState(undefined);
  const [dayOfMonthValue, setDayOfMonthValue] = useState(undefined);
  const [popupValue, setPopupValue] = useState(undefined);
  const [lastday, setLastday] = useState(false);
  const [newDataRecieved, setNewDataRecieved] = useState(false);

  const clearData = () => {
    setMonthValue(undefined);
    setWeekValue(undefined);
    setDayOfWeekValue(undefined);
    setDayOfMonthValue(undefined);
    setPopupValue("");
  };

  let internalContent = <div>Incorrect Schedule Type or Frequency</div>;

  const dateSelected = (e) => {
    setDayOfMonthValue(e.target.value);
    setTriggerSchedule(e.target.value);
    setLastday(false);
  };

  const changeLastDay = () => {
    setLastday(true);
    setDayOfMonthValue("last day");
    setTriggerSchedule(lastDayConst);
  };

  const weekSelected = (e) => {
    // console.log("WEEK :", e.target.value);
    setWeekValue(e.target.value);
  };

  const dayOfWeekSelected = (e) => {
    // console.log("DAY :", e.target.value);
    setDayOfWeekValue(e.target.value);
  };

  const monthSelectedRadio = (e) => {
    // console.log("MONTH :", e.target.value);
    setMonthValue(e.target.value);
  };

  const monthSelectedDropdown = (month) => {
    // console.log("MONTH :", month);
    setMonthValue(month);
  };

  useEffect(() => {
    // console.log("Month", monthValue);
    // console.log("Week of Month", weekValue);
    // console.log("Day of Week", dayOfWeekValue);
    // console.log("Day of Month", dayOfMonthValue);

    let formattedPopupValue = "";
    let formattedScheduleValue = "";

    if (triggerScheduleType === 1) {
      if (triggerFrequency === scheduleFrequencies.MONTHLY) {
        if (!dayOfMonthValue) {
          return;
        }
        formattedPopupValue = dayOfMonthValue;
        formattedScheduleValue = dayOfMonthValue;
      } else if (triggerFrequency === scheduleFrequencies.QUARTERLY) {
        if (!monthValue && !dayOfMonthValue) {
          return;
        }
        if (!monthValue) {
          setMonthValue(1);
          return;
        } else if (!dayOfMonthValue) {
          setDayOfMonthValue(1);
          return;
        }
        formattedPopupValue =
          monthValue + getSuffix(monthValue) + " month " + dayOfMonthValue;
        formattedScheduleValue =
          monthValue + "_" + lastday ? lastDayConst : dayOfMonthValue;
      } else if (triggerFrequency === scheduleFrequencies.YEARLY) {
        if (!monthValue && !dayOfMonthValue) {
          return;
        }
        if (!monthValue) {
          setMonthValue("1");
          return;
        } else if (dayOfMonthValue === undefined) {
          setDayOfMonthValue(1);
          return;
        }

        formattedPopupValue =
          monthValue + getSuffix(monthValue) + " month " + dayOfMonthValue;
        formattedScheduleValue =
          monthValue + "_" + lastday ? lastDayConst : dayOfMonthValue;
      } else {
        return;
      }
    } else if (triggerScheduleType === 2) {
      if (triggerFrequency === scheduleFrequencies.MONTHLY) {
        if (!weekValue && dayOfWeekValue === undefined) {
          return;
        } else if (!weekValue) {
          setWeekValue(1);
          return;
        } else if (dayOfWeekValue === undefined) {
          setDayOfWeekValue(1);
          return;
        }
        formattedPopupValue =
          weekValue +
          getSuffix(weekValue) +
          " week " +
          weekdays[dayOfWeekValue];
        formattedScheduleValue = weekValue + "_" + weekdays[dayOfWeekValue];
      } else if (triggerFrequency === scheduleFrequencies.QUARTERLY) {
        let redo = false;
        if (!weekValue && dayOfWeekValue === undefined && !monthValue) {
          return;
        } else if (!weekValue) {
          setWeekValue(1);
          redo = true;
        } else if (dayOfWeekValue === undefined) {
          setDayOfWeekValue(1);
          redo = true;
        } else if (!monthValue) {
          setMonthValue(1);
          redo = true;
        }
        if (redo) {
          return;
        }

        formattedPopupValue =
          monthValue +
          getSuffix(monthValue) +
          " month " +
          weekValue +
          getSuffix(weekValue) +
          " week " +
          weekdays[dayOfWeekValue];

        formattedScheduleValue =
          monthValue + "_" + weekValue + "_" + weekdays[dayOfWeekValue];
      } else if (triggerFrequency === scheduleFrequencies.YEARLY) {
        let redo = false;
        if (!weekValue && dayOfWeekValue === undefined && !monthValue) {
          return;
        } else if (!weekValue) {
          setWeekValue(1);
          redo = true;
        } else if (dayOfWeekValue === undefined) {
          setDayOfWeekValue(1);
          redo = true;
        } else if (!monthValue) {
          setMonthValue("1");
          redo = true;
        }
        if (redo) {
          return;
        }

        formattedPopupValue =
          monthValue +
          getSuffix(monthValue) +
          " month " +
          weekValue +
          getSuffix(weekValue) +
          " week " +
          weekdays[dayOfWeekValue];

        formattedScheduleValue =
          monthValue + "_" + weekValue + "_" + weekdays[dayOfWeekValue];
      } else {
        return "";
      }
    }

    setTriggerSchedule(formattedScheduleValue);
    setPopupValue(formattedPopupValue);
  }, [weekValue, dayOfWeekValue, monthValue, dayOfMonthValue]);

  const monthOfQuarterRadio = () => {
    return (
      <Radio.Group
        value={monthValue}
        buttonStyle="solid"
        onChange={monthSelectedRadio}
      >
        <Radio.Button value={1}>Month 1</Radio.Button>
        <Radio.Button value={2}>Month 2</Radio.Button>
        <Radio.Button value={3}>Month 3</Radio.Button>
      </Radio.Group>
    );
  };

  const monthOfYearSelector = () => {
    return (
      <Select
        style={{ width: 150 }}
        value={monthValue ? monthValue : ""}
        buttonStyle="solid"
        onChange={monthSelectedDropdown}
      >
        {simpleOptionGenerator(months)}
      </Select>
    );
  };

  const createDateOfMonthComponent = (triggerFrequency) => {
    let preSelector = undefined;

    switch (triggerFrequency) {
      case scheduleFrequencies.YEARLY:
        preSelector = monthOfYearSelector();
        break;
      case scheduleFrequencies.QUARTERLY:
        preSelector = monthOfQuarterRadio();
        break;
      default:
        break;
    }

    let comp = (
      <>
        <Space direction="vertical">
          {preSelector ? <Row justify="center">{preSelector}</Row> : <></>}
          <Row>
            <Radio.Group
              value={dayOfMonthValue}
              buttonStyle="solid"
              onChange={dateSelected}
            >
              {createMonthRadioOptions()}
              <Space direction="vertical">
                <Row>
                  <Checkbox checked={lastday} onChange={changeLastDay}>
                    End of Month
                  </Checkbox>
                </Row>
              </Space>
            </Radio.Group>
          </Row>
        </Space>
      </>
    );

    return comp;
  };

  const createWeekOfMonthComponent = (triggerFrequency) => {
    let preSelector = undefined;

    switch (triggerFrequency) {
      case scheduleFrequencies.YEARLY:
        preSelector = monthOfYearSelector();
        break;
      case scheduleFrequencies.QUARTERLY:
        preSelector = monthOfQuarterRadio();
        break;
      default:
        break;
    }

    let comp = (
      <div>
        <Space direction="vertical">
          <Space direction="vertical">
            {preSelector ? <Row justify="center">{preSelector}</Row> : <></>}
            <Space direction="vertical">
              <Row justify="center">
                <Radio.Group
                  value={weekValue}
                  buttonStyle="solid"
                  onChange={weekSelected}
                >
                  {createWeekOptions()}
                </Radio.Group>
              </Row>
              <Row>
                <Radio.Group
                  value={dayOfWeekValue}
                  buttonStyle="solid"
                  onChange={dayOfWeekSelected}
                >
                  {createDaysOfWeekOptions()}
                </Radio.Group>
              </Row>
            </Space>
          </Space>
        </Space>
      </div>
    );

    return comp;
  };

  if (triggerScheduleType === 1) {
    internalContent = createDateOfMonthComponent(triggerFrequency);
  } else if (triggerScheduleType === 2) {
    internalContent = createWeekOfMonthComponent(triggerFrequency);
  }

  const popoverContent = (
    <div>
      <Space direction="vertical">
        <Row justify="center">{internalContent}</Row>
      </Space>
    </div>
  );

  const popover = (
    <Popover content={popoverContent} trigger="click" placement="top">
      <Input
        value={popupValue}
        readOnly
        placeholder={placeholder}
      />
    </Popover>
  );

  if(newDataRecieved !== hotelChanged){
    if(presetValue){
      let newValue = reverseSchedule(presetValue, triggerFrequency, triggerScheduleType);
      setPopupValue(newValue);
      if(newValue === "last day"){
        changeLastDay();
      }
    }else{
      clearData();
    }
    setNewDataRecieved(hotelChanged);
  }

  return popover;
};

export default PopupTriggerSchedule;
